import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";
import {sampleFilterFual} from  "../pages/sample/ReportObj"


function LinearProgressBar(props) {
  //////
  const { colors, numbers, value,onClick  } = props;
  const useStyles = makeStyles((theme) => ({
    colorPrimary: {
      backgroundColor: "#eeeeee",
    },
    barColorPrimary: {
      backgroundColor: colors ? colors : "#000",
    },
    processBar: {
      height: 10,
      borderRadius: 5,
      boxShadow:10,
      
    },
   
  }));
  const classes = useStyles();

  function pad_with_zeroes(number, length) {
    var my_string = '' + number;
    while (my_string.length <= length) {
        my_string = my_string + '0';
    }
    return my_string;
  }
  const [formObj, setFormObj] = useState(sampleFilterFual);
const onChangeText = (event) => {
  ////
 //setFormObj({ ...formObj, [event.target.name]: event.target.value });
 //console.log(formObj);

};
 

  // //console.log(normalisevalue,'normalisevalue')
  return (
    <Box display="flex" alignItems="center">
      <Box width="0.9">

      <LinearProgress
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
          root: classes.processBar,
          bar: classes.processBar,
          
        }}
        variant="determinate"
        value={value}
        onClick={onClick}
        
      />
      </Box>
      <Box width="auto" pl={1}>{numbers}</Box>
 
    </Box>
  );
}

LinearProgressBar.propTypes = {};

export default LinearProgressBar;
